import React from 'react';
import {useIntl} from 'react-intl';

import {Link} from '@time-webkit/all/atoms/link';

import {EditorWrapper} from './wrapper';

import styles from './read_only_channel_with_join_link.module.css';

type Props = {
    isThread?: boolean;
    onClick?: () => void;
}

export const ReadOnlyChannelWithJoinLink = ({
    isThread = false,
    onClick,
}: Props) => {
    const {formatMessage} = useIntl();

    return (
        <EditorWrapper>
            <Link onClick={onClick} className={styles.linkPadding}>
                {formatMessage({
                    id: 'editor_state.read_only_channel.join_link',
                    defaultMessage: 'Join the channel,',
                })}
            </Link>
            {formatMessage({
                id: isThread ? 'editor_state.read_only_thread' : 'editor_state.read_only_channel',
                defaultMessage: isThread ? 'to send a message to the thread' : 'to send a message',
            })}
        </EditorWrapper>
    );
};
